export default "__VITE_ASSET__CcMPdc5e__"